import React, { useContext, useEffect, useState } from 'react'

import ChartWrapper from "../ChartWrapper"
import Chart from "./ContextChart.d3"

const ContextChart = ({
  data,
  events,
  transform,
  setSelection,
  setSelectedEvents,
  registerTimeChange
}) => {
  const triggerBrush = (event, chart) => {
    const [lower, upper] = event.selection
      ? event.selection.map(chart.xTime.invert, chart.xTime)
      : chart.xTime.range().map(chart.xTime.invert, chart.xTime)
    setSelectedEvents(chart.events.filter(e => e.date > lower && e.date < upper))
    setSelection(event)
  }

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{ data, events, triggerBrush, registerTimeChange }}
      updateProps={{ data, events }}
      margin={{ BOTTOM: 25, LEFT: 0}}
      useZoom={true}
      zoomProps={transform}
    />
  )
}

export default ContextChart
